import React from "react";
import { Link } from "react-router-dom";
import {Flame} from "lucide-react"
import "./cta.css";

const CTAButtonLink = ({ to, text, buttonText, icon: Icon, tabText }) => {
  return (
    <Link to={to} className="cta-button-fullwidth">
        {Icon && <Icon className="cta-icon" />}
      <div className="cta-content">
        <h3 className="cta-text">{text}</h3>
      </div>
      {
        tabText ? 
      <div className="cta-tab">
        <Flame/>{tabText}
      </div>
      : <></>
      }
      <div className="cta-button">
        {buttonText}
      </div>
    </Link>
  );
};

export default CTAButtonLink;
